import axios from 'axios';
import '../config';

const passwordResetApi = {
  reset: async ({ email, code, password }) => {
    const response = await axios.post(`${global.config.url}/Auth/reset-password`, { email, code, password });
    if (response.status !== 200 || !response.data || typeof response.data.message !== 'string' || !response.data.message.trim()) {
      throw new Error('The server did not confirm the password change.');
    }
    return { message: response.data.message };
  },
};

export default passwordResetApi;
